<template>
  <div>
    <date-range-picker
      ref="picker"
      :locale-data="localData"
      :ranges="showQuickRanges"
      :opens="direction"
      :minDate="minDate"
      :maxDate="maxDate"
      :singleDatePicker="useRange ? 'range' : 'single'"
      :timePicker="useTimePicker"
      :timePicker24Hour="timePicker24Hour"
      :showWeekNumbers="showWeekNumbers"
      :showDropdowns="showDropdowns"
      :autoApply="autoApply"
      v-model="date"
      @update="dateSelected"
      @toggle="togglePicker"
      :linkedCalendars="false"
      :dateFormat="dateFormatter"
      class="date-range-picker"
      :class="inputClass"
    >
      <template v-slot:input="picker">
        <div class="picker-container">
          <span class="icon-left" v-if="leftCalendarIcon">
            <calendar-icon />
          </span>
          <p class="date-text">
            {{ picker.startDate ? formatDate(picker.startDate) : "" }}
            <span v-if="useRange"
              >- {{ picker.endDate ? formatDate(picker.endDate) : "" }}
            </span>
          </p>
          <span class="icon-right" v-if="rightCalendarIcon">
            <calendar-icon />
          </span>
        </div>
      </template>
    </date-range-picker>
  </div>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
import CalendarIcon from "@/components/svg/CalendarIcon";

export default {
  name: "Calender",
  props: {
    leftCalendarIcon: {
      type: Boolean,
      default: false,
    },

    rightCalendarIcon: {
      type: Boolean,
      default: true,
    },

    useRange: {
      type: Boolean,
    },

    showQuickRanges: {
      type: Boolean,
    },

    useTimePicker: {
      type: Boolean,
    },

    timePicker24Hour: {
      type: Boolean,
    },

    showWeekNumbers: {
      type: Boolean,
    },

    showDropdowns: {
      type: Boolean,
      default: true,
    },

    autoApply: {
      type: Boolean,
      default: true,
    },

    disablePastDates: {
      type: Boolean,
    },

    direction: {
      type: String,
      default: "center",
    },

    dateFormat: {
      type: String,
      default: "D MMM",
    },

    minDate: {
      type: String,
      default: null,
    },

    maxDate: {
      type: String,
      default: null,
    },

    setDate: {
      type: [String, Array, Object],
      default: function () {
        return {
          startDate: moment().subtract(1, "days").format(),
          endDate: moment().format(),
        };
      },
    },

    inputClass: {
      type: String,
      default: "no-border",
      //  classes are
      //  no-border
      //  basic
    },
  },

  components: {
    CalendarIcon,
    DateRangePicker: DateRangePicker,
  },

  data() {
    return {
      calender: null,
      date: this.setDate,
      localData: {
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        format: this.dateFormat,
        firstDay: 1,
      },
    };
  },

  mounted() {
    // if (this.setDate) {
    //   this.date = this.setDate;
    // }
  },

  methods: {
    dateSelected(date) {
      this.$emit("change", date);
    },

    togglePicker(isOpen) {
      // this.date = this.setDate;
      return isOpen;
    },

    dateFormatter(classes, date) {
      if (
        this.disablePastDates &&
        !this.minDate &&
        !this.maxDate &&
        !classes.disabled
      ) {
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },

    getDay(value) {
      let dt = new Date(value);
      return dt.getDate();
    },

    formatDate(date) {
      return moment(date).format(this.dateFormat);
    },
  },
};
</script>
<style lang="scss">
.date-range-picker {
  --v-calendar-action-color: #e00b5b;

  width: 100%;

  .show-calendar {
    box-shadow: -50px 50px 51.8617px rgba(183, 183, 183, 0.25);
    border-radius: 20px;
  }

  //  the month and year separator
  th.month {
    font-family: Calibre;
    font-style: normal;

    .monthselect {
      display: block;
      width: 100%;
      text-align: center;
      border: 0px;
      outline: 0px;
      margin-bottom: 0.45rem;
      color: var(--v-calendar-action-color);
      font-weight: 500 !important;
      font-size: 0.875rem !important;
      line-height: 1.063rem !important;

      /* for Firefox */
      -moz-appearance: none;
      /* for Safari, Chrome, Opera */
      -webkit-appearance: none;

      &::-ms-expand {
        display: none;
      }
    }

    .yearselect {
      width: 100%;
      text-align: center;
      border: 0px;
      outline: 0px;
      font-weight: 500 !important;
      font-size: 0.875rem !important;
      line-height: 1.063rem !important;
      color: #000000;
    }
  }

  //calendar
  .calendars {
    .calendars-container {
      .drp-calendar {
        padding: 2.5rem 1.875rem;
        max-width: 24.375rem;
        width: 24.375rem;

        .calendar-table {
          padding-right: 0;

          table {
            border-collapse: separate;
            thead {
              tr {
                th {
                  padding-bottom: 0.9rem;
                  border-bottom: 0.976454px solid #f5f8fc;

                  &.prev {
                    padding-bottom: 0;
                    span {
                      background: url("../assets/arrow-left-circle.svg");
                      height: 1.463rem;
                      width: 1.463rem;
                      border: none;
                      transform: none;
                    }
                  }

                  &.next {
                    padding-bottom: 0;
                    span {
                      background: url("../assets/arrow-right-circle.svg");
                      height: 1.463rem;
                      width: 1.463rem;
                      border: none;
                      transform: none;
                    }
                  }
                }
              }
            }
            tbody {
              tr {
                th,
                td {
                  font-family: Calibre;
                  font-style: normal;
                  font-weight: 500;
                  font-size: 0.875rem;
                  line-height: 1.063rem;
                  color: #333333;
                  padding-top: 0.5rem;
                  padding-bottom: 0.5rem;
                }
                th {
                  padding-top: 0.488rem;
                }

                td.in-range {
                  background: rgba(255, 114, 118, 0.1);
                }

                td.off {
                  color: #6c757d;
                }

                td.active {
                  background: var(--v-calendar-action-color);
                  color: white;
                  position: relative;
                  border: none;
                  border-radius: 50%;
                  width: 1.375rem;
                  height: 2.5rem;

                  &:before {
                    background: rgba(255, 114, 118, 0.1);
                    content: " ";
                    width: 50%;
                    position: absolute;
                    height: 100%;
                    color: white;
                    top: 0;
                    left: 0;
                  }

                  &.start-date:before {
                    left: unset;
                    right: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  //variants
  &.no-border {
    .form-control {
      border: none;

      .picker-container {
        .date-text {
          font-family: Calibre;
          font-style: normal;
          font-weight: normal;
          font-size: 0.75rem;
          line-height: 0.875rem;
          /* identical to box height, or 117% */
          text-decoration-line: underline;
          color: rgba(38, 25, 64, 0.7);
        }
      }
    }
  }

  .picker-container {
    display: flex;
    align-items: flex-end;
  }
}

//for the icons
.icon-auto .picker-container {
  .icon-left {
    display: contents;
    svg {
      margin-right: auto;
    }
  }
  .icon-right {
    display: contents;
    svg {
      margin-left: auto;
    }
  }
}

//for form input
.form-input .picker-container {
  margin-bottom: 0.3rem;
  .date-text {
    font-size: 1rem !important;
    text-decoration-line: none !important;
    line-height: 117%;
  }
}
</style>
